var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    { attrs: { name: "profile-settings-modal", clickToClose: false } },
    [
      _c("div", { staticClass: "modal-container" }, [
        _c(
          "div",
          { staticClass: "modal-header" },
          [
            _c("page-title", { staticClass: "modal-title" }, [
              _vm._v("My Profile Settings"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "modal-description" }, [
              _vm._v("Review or update your account settings below."),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "activity-tabs-wrapper" }, [
            _c(
              "div",
              {
                class: { "activity-tab": true, active: _vm.activeTab === 1 },
                on: {
                  click: function ($event) {
                    return _vm.handleClickTab(1)
                  },
                },
              },
              [_vm._v("\n          Edit Profile\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { "activity-tab": true, active: _vm.activeTab === 2 },
                on: {
                  click: function ($event) {
                    return _vm.handleClickTab(2)
                  },
                },
              },
              [_vm._v("\n          Password\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { "activity-tab": true, active: _vm.activeTab === 3 },
                on: {
                  click: function ($event) {
                    return _vm.handleClickTab(3)
                  },
                },
              },
              [_vm._v("\n          Social\n        ")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-panel-wrapper" },
            [
              _c("edit-profile-panel", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 1,
                    expression: "activeTab === 1",
                  },
                ],
                staticClass: "profile-panel",
                on: {
                  onSubscription: function ($event) {
                    return _vm.$emit("onSubscription")
                  },
                  close: _vm.closeModal,
                },
              }),
              _vm._v(" "),
              _c("password-setting-panel", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 2,
                    expression: "activeTab === 2",
                  },
                ],
                on: { close: _vm.closeModal },
              }),
              _vm._v(" "),
              _c("social-accounts-panel", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 3,
                    expression: "activeTab === 3",
                  },
                ],
                on: { close: _vm.closeModal },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }